import { createStyles, rem } from '@mantine/core'

export default createStyles((theme, _params) => {
  return {
    root: {
      borderBottom: `${rem(1)} solid ${theme.colors.gray[2]}`,
    },
  }
})
